import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, renderList as _renderList, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '@/assets/images/icons/Money.png'


const _hoisted_1 = { class: "list money" }
const _hoisted_2 = {
  key: 0,
  class: "prize-empty"
}
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "prize-empty" }, "感謝參加 🙏", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "prize-empty" }, "您的抽獎次數已全部使用完畢，感謝參與～", -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "prize-empty" }, "敬請期待下次活動，再來試試手氣！", -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "prize-title" }, "轉盤好禮", -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "item-icon" }, [
  /*#__PURE__*/_createVNode("img", { src: _imports_0 })
], -1)
const _hoisted_8 = { class: "item-content" }
const _hoisted_9 = { class: "item-text" }
const _hoisted_10 = { class: "item-time" }
const _hoisted_11 = { class: "item-number" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.isValid(_ctx.recordState.result) && _ctx.recordState.result.length === 0 && _ctx.playTimes > 0)
      ? (_openBlock(), _createBlock("div", _hoisted_2, "您還未抽獎"))
      : (_ctx.isValid(_ctx.recordState.result) && _ctx.recordState.result.length === 0)
        ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
            _hoisted_3,
            _hoisted_4,
            _hoisted_5
          ], 64))
        : (_openBlock(), _createBlock(_Fragment, { key: 2 }, [
            _hoisted_6,
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.recordState.result, (item, index) => {
              return (_openBlock(), _createBlock("div", {
                class: "item",
                key: index
              }, [
                _hoisted_7,
                _createVNode("div", _hoisted_8, [
                  _createVNode("div", _hoisted_9, "恭喜您在「" + _toDisplayString(item.game_name) + "」中獲得了儲值金", 1),
                  _createVNode("div", _hoisted_10, _toDisplayString(item.date), 1)
                ]),
                _createVNode("div", _hoisted_11, "+" + _toDisplayString(item.prize_point), 1)
              ]))
            }), 128))
          ], 64))
  ]))
}